export default (function (svgString) {
  var match = svgString.match(/<svg (.*?)>(.*?)<\/svg>/);
  var attributes = {};
  var currentAttribute = [];

  if (match) {
    var attributesString = match[1],
        innerHTML = match[2];
    var getAttributes = /(\S*?)="(.*?)"/g;

    while ((currentAttribute = getAttributes.exec(attributesString)) !== null) {
      attributes[currentAttribute[1]] = currentAttribute[2];
    }

    return {
      attributes: attributes,
      innerHTML: innerHTML
    };
  }

  return {
    attributes: attributes,
    innerHTML: ''
  };
});